/* gclid-capture.js — writes to cart attributes + order note + line item properties */
(function () {
  var ATTR_KEYS = ["gclid", "gbraid", "wbraid"];
  var LEGACY_KEYS = ["GCLID"];         // clean any old uppercase key
  var COOKIE_TTL_DAYS = 90;

  function setCookie(name, value, days) {
    try {
      var d = new Date();
      d.setTime(d.getTime() + (days * 24*60*60*1000));
      document.cookie = name + "=" + encodeURIComponent(value) + "; expires=" + d.toUTCString() + "; path=/; SameSite=Lax";
    } catch(e){}
  }
  function getCookie(name) {
    var m = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return m ? decodeURIComponent(m[2]) : null;
  }
  function getParam(name) {
    try {
      var params = new URLSearchParams(window.location.search);
      return params.get(name);
    } catch(e){ return null; }
  }
  function parseGclidFromGclAw() {
    var candidates = [getCookie("_gcl_aw"), getCookie("_gcl_dc")];
    for (var i = 0; i < candidates.length; i++) {
      var c = candidates[i];
      if (!c) continue;
      var idx = c.indexOf("gclid=");
      if (idx > -1) {
        var g = c.substring(idx + 6).split(/[;|&]/)[0];
        if (g) return g;
      }
    }
    return null;
  }

  // Collect values: URL > Google cookie fallback > our cookie
  var values = {};
  ATTR_KEYS.forEach(function (k) {
    var v = getParam(k);
    if (!v && k === "gclid") v = parseGclidFromGclAw();
    if (!v) v = getCookie(k);
    if (v) { values[k] = v; setCookie(k, v, COOKIE_TTL_DAYS); }
  });
  if (Object.keys(values).length === 0) return;

  // 1) CART ATTRIBUTES (still do this)
  var payload = {};
  Object.keys(values).forEach(function (k) {
    payload["attributes[" + k + "]"] = values[k];
  });
  LEGACY_KEYS.forEach(function (k) { payload["attributes[" + k + "]"] = ""; }); // clear uppercase

  // 2) ORDER NOTE (many third-party checkouts carry 'note' → shows on order)
  var noteParts = [];
  if (values.gclid)  noteParts.push("gclid=" + values.gclid);
  if (values.gbraid) noteParts.push("gbraid=" + values.gbraid);
  if (values.wbraid) noteParts.push("wbraid=" + values.wbraid);

  // Merge with existing note if present (lightweight)
  function setCartNoteString(existingNote) {
    var note = (existingNote ? (existingNote + " | ") : "") + noteParts.join("; ");
    payload["note"] = note;
  }

  // 3) LINE ITEM PROPERTIES (prefixed underscore to keep low-profile)
  function setLineItemProperties(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    cart.items.forEach(function (item) {
      var props = {};
      if (values.gclid)  props["_gclid"]  = values.gclid;
      if (values.gbraid) props["_gbraid"] = values.gbraid;
      if (values.wbraid) props["_wbraid"] = values.wbraid;

      // Build change payload per item
      var form = new URLSearchParams();
      form.append("id", item.key); // item key is safest
      form.append("quantity", item.quantity);
      Object.keys(props).forEach(function (k) {
        form.append("properties["+k+"]", props[k]);
      });

      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8" },
        body: form.toString(),
        credentials: "same-origin"
      }).catch(function(){});
    });
  }

  // Update attributes + note, then update line-item properties
  function updateAll(attempt) {
    attempt = attempt || 1;
    // Get current cart first to preserve/merge note and to know items
    fetch("/cart.js", { credentials: "same-origin" })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        setCartNoteString(cart.note || "");
        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8" },
          body: new URLSearchParams(payload).toString(),
          credentials: "same-origin"
        }).then(function(){ setLineItemProperties(cart); });
      })
      .catch(function(){
        if (attempt < 3) setTimeout(function(){ updateAll(attempt+1); }, 400*attempt);
      });
  }

  updateAll(1);
})();
